import { Axios } from './plugins/axios'

// Auth
export const login = phone => Axios.post('login', { 'phone': phone });
export const loginByLine = lineId => Axios.post('login/line', { 'line_bot_id': lineId });
export const verify = payload => Axios.post('verify', payload);


// User
export const me = () => Axios.get('me');
export const updateMe = payload => Axios.put('me', payload);
export const histories = (value) => Axios.get('me/histories', { params: {keyword: value} });
export const changePhone = phone => Axios.post('me/phone/change', { 'phone': phone });
export const verifyPhone = payload => Axios.post('me/phone/verify', payload);
export const searchHistories = keywords => Axios.get('me/search/histories', { params: {keywords: keywords}});
export const setDevice = payload => Axios.post('devices', payload);
export const setAnonymityDevice = payload => Axios.post('devices/anonymity', payload);
export const log = payload => Axios.post('log', payload);
export const logout = payload => Axios.post('logout', payload);
export const unrated = () => Axios.get('me/unrated');
export const rated = lastId =>  Axios.put('me/rated', { last_score_order_id: lastId });
export const invitedCount = () => Axios.get('me/invited');

// Address
export const getAddresses = () => Axios.get('addresses');
export const setDefaultAddress = id => Axios.put(`addresses/${id}/default`);
export const deleteAddress = id => Axios.delete(`addresses/${id}`);
export const putAddress = payload => Axios.put(`addresses/${payload.id}`, payload.data);
export const createAddress = payload => Axios.post('addresses', payload);
export const getRegion = payload => Axios.get(`region`, { params: payload});

// Advertisement
export const Ads = () => Axios.get('advertisements');

// Shops
export const getShops = payload => Axios.get('shops', { params: payload });
export const getNearbyShops = payload => Axios.get('shops/nearby', { params: payload });
export const getShop = payload => Axios.get(`shops/${payload.id}`, { params: payload.params });
export const sendShopSuggest = payload => Axios.post(`shops/${payload.id}/suggest`, payload.params);
export const getShopProduct = id => Axios.get(`shops/product/${id}`);

// Coupon
export const addCoupon = payload => Axios.post('coupons', payload);
export const getCoupons = payload => Axios.get('coupons', { params: payload });
export const getUsedCoupons = payload => Axios.get('coupons/used', { params: payload });
export const getExpiredCoupons = payload => Axios.get('coupons/expired', { params: payload });

// Order
export const getOrders = payload => Axios.get('orders', { params: payload });
export const getOrder = (id, data = null) => Axios.get(`orders/${id}`, { params: data });
export const putOrder = payload => Axios.put(`orders/${payload.id}`, payload.data);
export const trial = payload => Axios.post('orders/trial', payload);
export const createOrder = payload => Axios.post('orders', payload);
export const restartOrder = payload => Axios.put(`orders/${payload.id}/restart`, payload.data);
export const revokeOrder = payload => Axios.put(`orders/${payload.id}/revoke`, payload.data);
export const cancelOrder = payload => Axios.put(`orders/${payload.id}/cancel`, payload.data);
export const cancelTrial = id => Axios.get(`orders/${id}/trial/cancel`);
export const scoreOrder = payload => Axios.post(`orders/${payload.id}/score`, payload.data);
export const getShareOrderUrl = id => Axios.get(`orders/${id}/shareOrderStatusUrl`);
export const getPosition = id => Axios.get(`orders/${id}/position`);
export const deleteOrder = id => Axios.delete(`orders/${id}`);
export const extendPairing = id => Axios.put(`orders/${id}/extend/pairing`);

// Agreement
export const getAgreements = () => Axios.get('agreements');
export const bindAgreements = () => Axios.get('agreements/bind');
export const setDefaultAgreement = id => Axios.put(`agreements/${id}/default`);
export const deleteAgreement = id => Axios.delete(`agreements/${id}`);
export const setDefaultCash = () => Axios.put(`agreements/cash/default`);

// Payment
export const pay = payload => Axios.put(`payments/${payload.id}`, payload.data);
export const getPaymentFormData = payload => Axios.post(`payments/data`, payload);

// Donate
export const donate = payload => Axios.post(`donate/${payload.id}`, payload.data);

// pusher
export const getPusherAuth = payload => Axios.post('/broadcasting/auth', payload);

// System
export const getSystempParameter = () => Axios.get('parameter');
export const getReserve = () => Axios.get('parameter/reserve');
export const verifyTime = time => Axios.post('parameter/time', { time: time });

// Category
export const getCategories = payload => Axios.get('categories', {params: payload});

// Favorite
export const getFavorites = () => Axios.get('favorites');
export const addFavorite = shopId => Axios.post(`favorites/shops/${shopId}`);
export const deleteFavorite = shopId => Axios.delete(`favorites/shops/${shopId}`);


// Brand
export const getBrandShops = payload => Axios.get(`brands/${payload.id}/shops`, { params: payload.params });

// Menu
export const getMenus = () => Axios.get('menus');


// Notify
export const getNotices = () => Axios.get('notices');
export const getUnreadNoticeCount = () => Axios.get('notices/unread');


// Designate
export const getDriverTop = type => Axios.get(`favorites/drivers`, { params: { limit: 3, type: type } });
export const getOrderTop = type => Axios.get('driver/orders', { params: { limit: 5, type: type } });
export const searchDriver = keyword => Axios.get('driver/search', { params: { keyword: keyword }});
export const getDriverIds = () => Axios.get('driver/ids');
export const getBlockIds = () => Axios.get('driver/block/ids');
export const blockDriver = payload => Axios.post(`block/drivers/${payload.id}`, payload.data);
export const unblockDriver = id => Axios.delete(`block/drivers/${id}`);
export const addDriver = id => Axios.post(`favorites/drivers/${id}`);
export const deleteDriver = id => Axios.delete(`favorites/drivers/${id}`);
export const getDrivers = payload => Axios.get('favorites/drivers', { params: payload });
export const getOrdersDriver = payload => Axios.get('driver/orders', { params: payload });

// Share
export const getShareOrder = code => Axios.get(`share/${code}`);
export const getSharePosition = code => Axios.get(`share/${code}/position`);

// Message
export const getOrderMessage = payload => Axios.get(`message/order/${payload.id}`, { params: payload.data });
export const getMessage = id => Axios.get(`message/${id}`);
export const pushOrderMessage = payload => Axios.post(`message/order/${payload.id}`, payload.data);
export const getUnreadOrderMessages = () => Axios.get(`message/order/unread`);

// Activity
export const getActivities = () => Axios.get(`activity`);